import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { constants } from '@dc/ui-library/src/config';
import { saveToSessionStorage, removeFromSessionStorage } from
  '@dc/ui-library/src/helpers/sessionStorage';

import { removeProduct } from '../../../../appState/ducks/listingPageComparison';
import ComparePanel from './ComparePanel.jsx';
import Analytics from '../../../../analytics';
import { showOrHideEmailMeBackFormForProduct } from '../../../../email-oos';

class CompareBlock extends React.Component {
  constructor(props) {
    super(props);

    this.removeProduct = this.removeProduct.bind(this);
    this.onCompareButtonClick = this.onCompareButtonClick.bind(this);
    this.onClickProductImage = this.onClickProductImage.bind(this);
  }

  onCompareButtonClick() {
    Analytics.dispatchClickCompareButton(this.props.products.map(product => product.id));

    // saves url pathname of current listing page to session storage
    // which is used in backButton on compare page
    saveToSessionStorage(
      constants.SESSION_STORAGE_COMPARISON_LAST_PAGE_PATH,
      window.location.pathname
    );
    removeFromSessionStorage(
      constants.SESSION_STORAGE_COMPARISON_BACK_LINK_LABEL
    );
  }

  onClickProductImage(product) {
    Analytics.dispatchClickProductImage(product);
  }

  removeProduct(product) {
    this.props.removeProduct({ product, productSegmentId: this.props.productSegmentId });
    Analytics.dispatchUncheckProduct(product);
  }


  render() {
    return (
      <ComparePanel
        translations={this.props.translations}
        products={this.props.products}
        onRemoveProduct={this.removeProduct}
        onPopupDisplay={this.onClickProductImage}
        buttonClick={this.onCompareButtonClick}
        onEmailMeButtonClickInTooltip={showOrHideEmailMeBackFormForProduct}
      />
    );
  }
}

CompareBlock.propTypes = {
  productSegmentId: PropTypes.PropTypes.number.isRequired,
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  products: PropTypes.arrayOf(PropTypes.object),
  removeProduct: PropTypes.func
};

CompareBlock.defaultProps = {
  products: [],
  removeProduct: () => {}
};

function mapStateToProps(state) {
  const currentPageSegmentId = state.listingPage.pageSetup.category.segmentId;
  return {
    products: state.listingPage.comparison.products[currentPageSegmentId] || [],
    productSegmentId: currentPageSegmentId
  };
}

export default connect(mapStateToProps, { removeProduct })(CompareBlock);
